// mode
export const ENV: string = process.env.NODE_ENV || "development";
export const MODE_DEBUG: boolean = ENV !== "production";
export const ARYA_API_BASE_URL: string = process.env.ARYA_API_BASE_URL || "";
